module.exports = __webpack_public_path__ + "static/media/image_part_005.55a76908.jpg";